import React from 'react';

// Skeleton for platform metric cards
export const PlatformMetricSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-start justify-between mb-4">
      <div className="flex-1">
        <div className="h-4 bg-gray-200 rounded w-28 mb-3"></div>
        <div className="h-8 bg-gray-300 rounded w-20"></div>
      </div>
      <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
    </div>
    <div className="flex items-center gap-2 mt-4">
      <div className="h-3 bg-gray-200 rounded w-16"></div>
      <div className="h-3 bg-gray-200 rounded w-12"></div>
    </div>
  </div>
);

// Skeleton for user acquisition chart
export const AcquisitionChartSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-48"></div>
      <div className="flex gap-2">
        <div className="h-8 bg-gray-200 rounded w-20"></div>
        <div className="h-8 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
    <div className="h-72 bg-gray-100 rounded-lg"></div>
    <div className="flex justify-between mt-4">
      {[1, 2, 3, 4, 5, 6, 7]?.map((i) => (
        <div key={i} className="h-3 bg-gray-200 rounded w-10"></div>
      ))}
    </div>
  </div>
);

// Skeleton for engagement metrics panel
export const EngagementMetricsSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-40 mb-6"></div>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4]?.map((i) => (
        <div key={i} className="space-y-3">
          <div className="h-4 bg-gray-200 rounded w-32"></div>
          <div className="h-8 bg-gray-300 rounded w-20"></div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for geographic distribution
export const GeographicDistributionSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-48 mb-6"></div>
    <div className="space-y-4">
      {[1, 2, 3, 4, 5, 6]?.map((i) => (
        <div key={i} className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-300 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="h-6 bg-gray-200 rounded" style={{ width: `${100 - i * 10}%` }}></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for realtime monitor
export const RealtimeMonitorSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-40"></div>
      <div className="w-3 h-3 bg-green-200 rounded-full"></div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {[1, 2, 3]?.map((i) => (
        <div key={i} className="p-4 bg-gray-50 rounded-lg space-y-3">
          <div className="h-4 bg-gray-200 rounded w-28"></div>
          <div className="h-10 bg-gray-300 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for feature usage matrix
export const FeatureUsageMatrixSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-48 mb-6"></div>
    <div className="space-y-3">
      {[1, 2, 3, 4, 5, 6]?.map((i) => (
        <div key={i} className="flex items-center gap-4">
          <div className="h-4 bg-gray-300 rounded w-40 flex-shrink-0"></div>
          <div className="flex-1 h-8 bg-gray-100 rounded-lg"></div>
          <div className="h-4 bg-gray-200 rounded w-16 flex-shrink-0"></div>
        </div>
      ))}
    </div>
  </div>
);